ActiveLabelTool.prototype._buildLabel = function (oLabel, nPanel) {
	var sType = this._getPanelTypeByUid(oLabel.Uid, nPanel) || this._getOverlayTypeByUID(oLabel.Uid, nPanel) || "Price";
    sType = this._processType(sType, oLabel);

    var sLabelClass = "price";
    if (nPanel > 0) {
        sLabelClass = "active-label-lower";
    }

    //any upper indicator that is not price
    var isButton = (nPanel == 0 && sType != "Price");

    if (isButton) {
        var jLabel = $("<span class=''><em class='indicator'></em></span>");
    } else {
        var jLabel = $("<div class='active-label contain " + sLabelClass + "'><em class='indicator'></em></div>");
    }

    $("em", jLabel).css({ "background-color": oLabel.Color });

    var rDatapoints = this.LABEL_DETAIL_BY_TYPE[sType];
    //console.log(sType, rDatapoints)
    if (!rDatapoints) { return false; }

    for (var i = 0; i < rDatapoints.length; i++) {
        var oData = rDatapoints[i];

        if (!oData) { continue; }

        var showParameterLabel =
				this.ShowParameterLabels &&
				oLabel.Parameters != "" &&
				oData.ShowParameterLabel;

        if (oData.GroupDisplay) {
            var bRemovable = true;
            var sGroupDisplay = oData.GroupDisplay;
            var bIsComparison = sType == "PriceComparison";
            if (bIsComparison) {
                sGroupDisplay = oLabel.Label;
            }
            if (sGroupDisplay == "IssueDisplayName") {
                sGroupDisplay = this._chart.GetIssueDisplayName();
                bRemovable = false;
            }
            var jInner = $("<label></label>");

            jInner.append("<span class='" + sGroupDisplay.split(' ').join('') + "'>" + (showParameterLabel ? (oLabel.Parameters + "-") : "") + sGroupDisplay + "</span>");

            jLabel.append(jInner);
            if (bRemovable) {
                jLabel.append("<span class='icon icon-remove'></span>");
            }
            $("span.icon-remove", jLabel).on("click", this._handleRemoveLabel.eventContext(this, { data: { Uid: oLabel.Uid, IsComparison: bIsComparison } }));

        } else {
            var sDisplay = (isButton ? "" : this._getDataDisplay(sType, oData, oLabel));
            var sKey = this._processKey(oData.Key, oLabel, oData);

            var jDatapoint = $("<dl><dt><span class='" + sDisplay.split(' ').join('') + "'>" + (showParameterLabel ? (oLabel.Parameters + "-") : "") + sDisplay + "</span></dt><dd>" + (isButton && i == 1 ? "(" : "") + "<span>--</span>" + (isButton && i != rDatapoints.length - 1 ? "," : "") + (isButton && i == rDatapoints.length - 1 ? ")" : "") + "</dd></dl>")
					.addClass("active-label-" + sKey);

            jLabel.append(jDatapoint);

            this._labelsByDataKey[sType + "-" + sKey] = { Node: $("dd span", jDatapoint), Panel: nPanel, Key: sKey };
        }
    }

    if (isButton) {
        var button = $("<div class='btn btn-chart contain' type='button'></div>").append(jLabel);
        return $("<div class='active-label contain'></div>").append(button);
    } else {
        return jLabel;
    }
};

ActiveLabelTool.prototype.LABEL_DETAIL_BY_TYPE = {
    Price: [
			{ GroupDisplay: "IssueDisplayName" },
			{ Display: " ", Key: "Date" },
			{ Display: "Open", Key: "Open" },
			{ Display: "High", Key: "High" },
			{ Display: "Low", Key: "Low" },
			{ Display: "Close", Key: "Close" }
    //{ Display: "Percent Change", Key: "PctChange" }
		],
    PERatio: [
			{ Key: "PERatio" }
		],
    Revenue: [
			{ Display: "Revenues", Key: "Revenue" }
		],
    DividendYield: [
			{ Key: "DividendYield" }
		],
    RollingDividend: [
			{ Key: "RollingDividend" }
		],
    PriceComparison: [
			{ GroupDisplay: "PctChange" },
			{ Display: "% Change", Key: "PctChange", UseParametersInKey: true }
		],
    PSAR: [
			{ GroupDisplay: "Parabolic SAR" },
			{ Display: "Value", Key: "PSAR" }
		],
    PriceChannel: [
			{ GroupDisplay: "Price Channel" },
			{ Display: "Lower", Key: "PriceChannelLower" },
			{ Display: "Upper", Key: "PriceChannelUpper" }
		],
    TimeSeriesForecast: [
			{ GroupDisplay: "Time Series Forecast" },
			{ Display: "Value", Key: "TimeSeriesForecast" }
		],
    WMA: [
            { GroupDisplay: "Weighted Moving Average" },
			{ Key: "Value", Key: "WMA", AllowMultiple: true }
		],
    EMA: [
			{ GroupDisplay: "Exponential Moving Average" },
			{ Display: "Value", Key: "EMA", AllowMultiple: true }
		],
    SMA: [
			{ GroupDisplay: "Simple Moving Average", ShowParameterLabel: true },
			{ Display: "Value", Key: "SMA", AllowMultiple: true }
		],
    MovingAverageEnvelope: [
			{ GroupDisplay: "Moving Average Envelope" },
			{ Display: "Low", Key: "MovingAverageEnvelopeLow" },
			{ Display: "High", Key: "MovingAverageEnvelopeHigh" }
		],
    BollingerBands: [
			{ GroupDisplay: "Bollinger Bands" },
			{ Display: "Lower", Key: "BollingerLower", AllowMultiple: true },
			{ Display: "Upper", Key: "BollingerUpper", AllowMultiple: true }
    //{ Display: "Bollinger SMA", Key: "BollingerSMA", AllowMultiple: true }
		],
    BollingerBandsSMA: [
            { GroupDisplay: "Bollinger SMA" },
			{ Display: "Value", Key: "BollingerSMA", AllowMultiple: true }
		],
    Volume: [
			{ Display: "Shares Traded", Key: "Volume" }
		],
    VolumePlus: [
            { Display: "Shares Traded", Key: "Volume" }
    ],
    36: [
            { Display: "Shares Traded", Key: "Volume" }
    ],
    MoneyFlowIndex: [
			{ Key: "MoneyFlowIndex" }
		],
    OnBalanceVolume: [
			{ Key: "OnBalanceVolume" }
		],
    AccumulationDistribution: [
			{ Key: "AccumulationDistribution" }
		],
    "DMI_DMI": [
			{ Key: "DMI.ADX", Display: "DMI.ADX" }
		],
    "DMI_DMI.+": [
			{ Key: "DMI.+" }
		],
    "DMI_DMI.-": [
			{ Key: "DMI.-" }
		],
    ChaikinsVolatility: [
			{ Display: "Chaikin's Indicator", Key: "ChaikinsVolatility" }
		],
    "MassIndex_Mass Index": [
			{ Key: "MassIndex" }
		],
    MACDHistogram: [
			{ Display: "Moving Average Convergence/Divergence (Histogram)", Key: "Divergence" }
		],
    "MACD_MACD": [
			{ Display: "Moving Average Convergence/Divergence", Key: "MACD" }
		],
    "MACD_Signal Line": [
			{ Key: "EMA" }
		],
    "MACD_Divergence": [
			{ Display: " ", Key: "Divergence" }
		],
    Momentum: [
			{ Key: "Momentum" }
		],
    PriceRateOfChange: [
			{ Key: "RateOfChange" }
		],
    VLRelativeStrength: [
			{ Display: "Relative Strength to Index", Key: "RSI" }
		],
    "FastStochastics_%K": [
			{ Display: "Fast Stochastics", Key: "K" }
		],
    "FastStochastics_%D": [
			{ Key: "D" }
		],
    "SlowStochastics_%K": [
			{ Display: "Slow Stochastics", Key: "K" }
		],
    "SlowStochastics_%D": [
			{ Key: "D" }
		],
    UltimateOscillator: [
			{ Key: "UltimateOscillator" }
		],
    WilliamsPercentR: [
			{ Display: "Williams %R", Key: "WilliamsPercentR" }
		],
    LinearRegression: [
			{ GroupDisplay: "Linear Regression Line" }
		],
    RollingDividend: [
			{ Key: "Dividend" }
		],
    RollingEPS: [
			{ Key: "Earnings per Share" }
		],
    VLCashFlow: [
			{ Key: "\"Cash Flow\" per Share" }
    ],
	VLRatingChange: [
		{ GroupDisplay: "Show Rank Changes" }
	],
	Dividends: [
		{ GroupDisplay: "Show Dividends Paid" }
	],
	Earnings: [
		{ GroupDisplay: "Show Earnings Announced" }
	],
	Splits: [
		{ GroupDisplay: "Show Splits" }
	],
	VLResearchNote: [
		{ GroupDisplay: "Show Supplementary Reports" }
	],
	VLCommentary: [
		{ GroupDisplay: "Show Commentary" }
	],
	VLMarketCycle: [
		{ GroupDisplay: "Show Market Events" }
	]
};